export default __webpack_public_path__ + "8de8853cfb592d4a3bcadab3afe86e39.svg";